var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('swiper',{attrs:{"options":_vm.swiperOption}},[_vm._t("default"),(_vm.pagination)?_c('div',{staticClass:"swiper-pagination",attrs:{"slot":"pagination"},slot:"pagination"}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }